import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { DialogConfirmOptions, MessageType } from '../../src';
import { ThemeService } from '../theme/ThemeService';

@Component({
    selector: 'cas-confirm-dialog',
    styles: [`
        :host .message-content {
            padding: 24px;
        }
    `],
    templateUrl: './confirm-dialog.component.html' 
})
export class ConfirmDialogComponent implements OnInit {
    public isWarning: boolean;
    public confirmBtnText: string;
    public showCancelBtn: boolean;
    public cancelBtnText: string;
    public toolbarClass: string;
    public messages: string[];
    public icon: string;

    constructor(
        private dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogConfirmOptions,
        private themeService: ThemeService
    ) {
    }

    public ngOnInit() {
        this.toolbarClass = this.themeService.getBackgroundPrimaryClassHue2();
        this.icon = this.mapIcon();
        this.isWarning = this.data.messageType === MessageType.Warning;
        this.confirmBtnText = this.data.confirmBtnText || 'Yes';
        this.cancelBtnText = this.data.cancelBtnText || 'Cancel';
        this.showCancelBtn = this.data.showCancelBtn ?? true;
        this.runFormatterOnMessages();
    }

    private runFormatterOnMessages(){
        if (this.data?.messages && this.data?.formatter) {
            this.messages = this.data.messages.map(message => this.data.formatter(message));
        }
    }

    public confirmAction() {
        this.dialogRef.close(true);
    }

    public cancelAction() {
        this.dialogRef.close(false);
    }

    private mapIcon() {
        if (this.data.messageType === MessageType.Warning) {
            return 'warning';
        }

        return 'info_outline';
    }
}
